import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NewTableComponent } from './new-table/new-table.component';
import { TableCellComponent } from './new-table/table-cell/table-cell.component';
import { ButtonComponent } from './button/button.component';
import { NewButtonComponent } from './_design-components/button/button.component';
import { IconComponent } from './_design-components/icon/icon.component';
import { PaginationComponent } from './pagination/pagination.component';
import { LoadingSpinnerComponent } from './loading-spinner/loading-spinner.component';
import { AvatarComponent } from './avatar/avatar.component';

/**
 * Shared components module that exports reusable components
 * for use in feature modules without router dependencies
 */
@NgModule({
  declarations: [
    NewTableComponent,
    TableCellComponent,
    ButtonComponent,
    NewButtonComponent,
    IconComponent,
    PaginationComponent,
    LoadingSpinnerComponent,
    AvatarComponent,
  ],
  imports: [
    CommonModule,
    MatIconModule,
    MatMenuModule,
    MatCheckboxModule,
    MatButtonModule,
    MatTooltipModule,
  ],
  exports: [
    NewTableComponent,
    TableCellComponent,
    ButtonComponent,
    NewButtonComponent,
    IconComponent,
    PaginationComponent,
    LoadingSpinnerComponent,
    AvatarComponent,
  ],
})
export class SharedComponentsModule { }
